// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditAvatar_wrapper__2f8GR","cropper":"EditAvatar_cropper__3Bclo","save":"EditAvatar_save__15nYu"};